<app-widget-card-wrapper [title]="chartTitle" class="whenua">
  <h5 class="card-title-medium" style="color: #428644">{{ chartHeader }}</h5>
  <div class="card-stretch">
    <div>
      <h2><span>Click each analyte to turn data on and off.</span></h2>
    </div>
    <div echarts [options]="groundwaterOption" class="demo-chart"></div>
  </div>
</app-widget-card-wrapper>
